import { render, staticRenderFns } from "./DialogDisabled.vue?vue&type=template&id=68df5dc9&scoped=true"
import script from "./DialogDisabled.vue?vue&type=script&lang=ts"
export * from "./DialogDisabled.vue?vue&type=script&lang=ts"
import style0 from "./DialogDisabled.vue?vue&type=style&index=0&id=68df5dc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68df5dc9",
  null
  
)

export default component.exports